<template>
  <div class="temuManifestDetail">
    <van-form label-width="120px">
      <div class="title">{{ $t.meta.basicTitle }}</div>
      <div v-if="form.menuState == 1">
        <van-field
          v-model="form.order_customerinvoicecode"
          :label="$t.platformOrders.orderCustomerinvoicecode"
          readonly
          type="textarea"
          rows="3"
        >
          <template #button>
            <van-button size="small" type="info" @click="gotoTms">{{
              $t.meta.detail
            }}</van-button>
          </template>
        </van-field>
        <van-field
          v-model="form.WB_Number"
          :label="$t.platformOrders.wbNumber"
          readonly
        />
        <van-field
          v-model="form.order_piece"
          :label="$t.platformOrders.orderPiece"
          readonly
        />
        <van-field
          v-model="form.weight"
          :label="$t.platformOrders.weight"
          readonly
        />
        <van-field
          v-model="form.volume"
          :label="$t.platformOrders.volume"
          readonly
        />
        <van-field
          v-model="form.ExpectedDeliveryDate"
          :label="$t.platformOrders.expectedDeliveryDate"
          readonly
        />
        <van-field
          v-model="form.consignee_name"
          :label="$t.platformOrders.consigneeName"
          readonly
        />
        <van-field
          v-model="form.consignee_companyname"
          :label="$t.platformOrders.consigneeCompanyname"
          readonly
        />
        <van-field
          v-model="form.consignee_telephone"
          :label="$t.platformOrders.consigneeTelephone"
          readonly
        />
        <van-field
          v-model="form.consignee_countrycity"
          :label="$t.platformOrders.consigneeCountryCity"
          readonly
        />
        <van-field
          v-model="form.shipper_name"
          :label="$t.platformOrders.shipperName"
          readonly
        />
        <van-field
          v-model="form.shipper_companyname"
          :label="$t.platformOrders.shipperCompanyname"
          readonly
        />
        <van-field
          v-model="form.shipper_telephone"
          :label="$t.platformOrders.shipperTelephone"
          readonly
        />
        <van-field
          v-model="form.paymenttype_code"
          :label="$t.platformOrders.paymenttypeCode"
          readonly
        />
        <van-field
          v-model="form.order_codamount"
          :label="$t.platformOrders.orderCodamount"
          readonly
        />
        <van-field
          v-model="form.order_codcurrency"
          :label="$t.platformOrders.orderCodcurrency"
          readonly
        />
        <van-field
          v-model="form.CreateTime"
          :label="$t.platformOrders.orderDate"
          readonly
        />
      </div>
      <div v-else>
        <van-field
          v-model="form.MAWB"
          :label="$t.platformOrders.mawb"
          readonly
        />
        <van-field
          v-model="form.ReferenceNo"
          :label="$t.platformOrders.referenceNo"
          readonly
        />
        <van-field
          v-model="form.PackageNo"
          :label="$t.platformOrders.packageNo"
          readonly
        />
        <van-field
          v-model="form.BoxNo"
          :label="$t.platformOrders.boxNo"
          readonly
        />
        <van-field
          v-model="form.ConsigneeName"
          :label="$t.platformOrders.consigneeName"
          readonly
        />
        <van-field
          v-model="form.ConsigneeMobile1"
          :label="$t.platformOrders.consigneeMobile"
          readonly
        />
        <van-field
          v-model="form.ConsigneeCountry"
          :label="$t.platformOrders.consigneeCountry"
          readonly
        />
        <van-field
          v-model="form.ConsigneeCity"
          :label="$t.platformOrders.consigneeCity"
          readonly
        />
        <van-field
          v-model="form.ShipperName"
          :label="$t.platformOrders.shipperName"
          readonly
        />
        <van-field
          v-model="form.ShipperPhone"
          :label="$t.platformOrders.shipperPhone"
          readonly
        />
        <van-field
          v-model="form.ChargeableWeight"
          :label="$t.platformOrders.chargeableWeight"
          readonly
        />
        <van-field
          v-model="form.CodOrNonCod"
          :label="$t.platformOrders.codOrNonCod"
          readonly
        />
        <van-field
          v-model="form.CodAmount"
          :label="$t.platformOrders.orderCodamount"
          readonly
        />
        <van-field
          v-model="form.CodCurrency"
          :label="$t.platformOrders.orderCodcurrency"
          readonly
        />
        <van-field
          v-model="form.ItemDescEn"
          :label="$t.platformOrders.itemDescEn"
          readonly
        />
        <van-field
          v-model="form.ItemQuantity"
          :label="$t.platformOrders.itemQuantity"
          readonly
        />
        <van-field
          v-model="form.DeclareValue"
          :label="$t.platformOrders.declareValue"
          readonly
        />
        <van-field
          v-model="form.DeclareValueCurrency"
          :label="$t.platformOrders.declareValueCurrency"
          readonly
        />
        <van-field
          v-model="form.CreateTime"
          :label="$t.platformOrders.createTime"
          readonly
        />
      </div>
    </van-form>
  </div>
</template>
<script>
import Vue from "vue";
import { Form, Field, Button, Icon, Image } from "vant";

Vue.use(Form).use(Field).use(Button).use(Icon).use(Image);

export default {
  name: "temuManifestDetail",
  data() {
    return {
      CompanyId: JSON.parse(localStorage.getItem("auth")).userInfo.CompanyId,
      UserId: JSON.parse(localStorage.getItem("auth")).userInfo.UserId,
      form: {},
      menuState: 1,
      listAmount: [],
      cabinetClass: [],
    };
  },
  created() {
    var data = JSON.parse(localStorage.getItem("temuManifestDetail"));
    this.form = data;
    this.menuState = this.form.menuState;
  },
  methods: {
    gotoTms() {
      this.$commonEnv.commonAction(this.$commonEnv.actionType.routerPush, {
        isParams: true,
        path: "tmsDetail",
        name: "tmsDetail",
        query: [
          {
            name: "HOId",
            value: this.form.HOId,
          },
        ],
      });
    },
  },
};
</script>
<style lang="scss" scoped>
.temuManifestDetail {
  .van-cell {
    border-bottom: 1px solid #ebedf0;
  }
  .van-cell::after {
    border: none !important;
  }
  .subTotal {
    padding: 15px;
    font-size: 14px;
    color: #646566;
    .subTotal-label {
      margin-bottom: 15px;
    }
    .subTotal-item {
      display: inline-block;
      width: 33.33%;
      text-align: center;
      .item1 {
        padding: 10px;
        background: #1e90ff;
        color: #ffffff;
      }
      .item2 {
        padding: 10px;
        background: #e8f4ff;
      }
    }
  }
}
</style>
